import { Box, Center, Heading, Image, SimpleGrid, Text } from "@chakra-ui/react";
import reactlogo from '../logos/react-2.svg';
import htmllogo from '../logos/html-1.svg'
import csslogo from '../logos/css-3.svg'
import jslogo from '../logos/javascript-1.svg'
import gitlogo from '../logos/github-icon-1.svg'
import reduxlogo from '../logos/redux.svg'
import typescript from '../logos/typescript.svg'
import node from '../logos/nodejs-icon.svg'
import express from '../logos/express-109.svg'
import mongo from '../logos/mongodb-icon-1.svg'
import postman from '../logos/postman.svg'
import vscode from '../logos/visual-studio-code-1.svg'

export const Skills = () => {
    return (
        <div id="skills" style={{ borderBottom: '1px solid gray', marginTop: '20px' }}>
            <Heading color={'text'} mb='30px'>My <strong style={{ color: '#4FC3F7' }}>Technical </strong>Skills</Heading>
            <SimpleGrid gap={'40px'} columns={[1, 2, 3]} w={'80%'} m={'auto'} mb={'40px'} mt={'20px'}>
                {/* HTML */}
                <Box className="skills-card" border={'1px solid white'} p={'5px'} borderRadius='15px'>
                    <Center>
                        <Image className="skills-card-img" src={htmllogo} w={'150px'} h={'150px'} position={'relative'} transition={'transform .3s ease-in-out'} _hover={{ transform: 'rotateY(180deg)' }} />
                    </Center>
                    <Text className="skills-card-name" color={'white'} fontWeight='bold' fontSize={'2xl'}>HTML5</Text>
                </Box>
                {/* CSS */}
                <Box className="skills-card" border={'1px solid white'} p={'5px'} borderRadius='15px'>
                    <Center>
                        <Image className="skills-card-img" src={csslogo} w={'150px'} h={'150px'} position={'relative'} transition={'transform .3s ease-in-out'} _hover={{ transform: 'rotateY(180deg)' }} />
                    </Center>
                    <Text className="skills-card-name" color={'white'} fontWeight='bold' fontSize={'2xl'}>CSS3</Text>
                </Box>
                {/* JS */}
                <Box className="skills-card" border={'1px solid white'} p={'5px'} borderRadius='15px'>
                    <Center>
                        <Image className="skills-card-img" src={jslogo} w={'150px'} h={'150px'} position={'relative'} transition={'transform .3s ease-in-out'} _hover={{ transform: 'rotateY(180deg)' }} />
                    </Center>
                    <Text className="skills-card-name" color={'white'} fontWeight='bold' fontSize={'2xl'}>JavaScript</Text>
                </Box>
                {/* React */}
                <Box className="skills-card" border={'1px solid white'} p={'5px'} borderRadius='15px'>
                    <Center>
                        <Image className="skills-card-img" src={reactlogo} w={'150px'} h={'150px'} position={'relative'} transition={'transform .3s ease-in-out'} _hover={{ transform: 'rotateY(180deg)' }} />
                    </Center>
                    <Text className="skills-card-name" color={'white'} fontWeight='bold' fontSize={'2xl'}>React</Text>
                </Box>
                {/* Redux */}
                <Box className="skills-card" border={'1px solid white'} p={'5px'} borderRadius='15px'>
                    <Center>
                        <Image className="skills-card-img" src={reduxlogo} w={'150px'} h={'150px'} position={'relative'} transition={'transform .3s ease-in-out'} _hover={{ transform: 'rotateY(180deg)' }} />
                    </Center>
                    <Text className="skills-card-name" color={'white'} fontWeight='bold' fontSize={'2xl'}>Redux</Text>
                </Box>
                {/* TypeScript */}
                <Box className="skills-card" border={'1px solid white'} p={'5px'} borderRadius='15px'>
                    <Center>
                        <Image className="skills-card-img" src={typescript} w={'150px'} h={'150px'} position={'relative'} transition={'transform .3s ease-in-out'} _hover={{ transform: 'rotateY(180deg)' }} />
                    </Center>
                    <Text className="skills-card-name" color={'white'} fontWeight='bold' fontSize={'2xl'}>TypeScript</Text>
                </Box>
                {/* Node */}
                <Box className="skills-card" border={'1px solid white'} p={'5px'} borderRadius='15px'>
                    <Center>
                        <Image className="skills-card-img" src={node} w={'150px'} h={'150px'} position={'relative'} transition={'transform .3s ease-in-out'} _hover={{ transform: 'rotateY(180deg)' }} />
                    </Center>
                    <Text className="skills-card-name" color={'white'} fontWeight='bold' fontSize={'2xl'}>Node</Text>
                </Box>
                {/* Express */}
                <Box className="skills-card" border={'1px solid white'} p={'5px'} borderRadius='15px'>
                    <Center>
                        <Image className="skills-card-img" src={express} backgroundColor='white' w={'150px'} h={'150px'} position={'relative'} transition={'transform .3s ease-in-out'} _hover={{ transform: 'rotateY(180deg)' }} />
                    </Center>
                    <Text className="skills-card-name" color={'white'} fontWeight='bold' fontSize={'2xl'}>Express</Text>
                </Box>
                {/* Mongo DB */}
                <Box className="skills-card" border={'1px solid white'} p={'5px'} borderRadius='15px'>
                    <Center>
                        <Image className="skills-card-img" src={mongo} w={'150px'} h={'150px'} position={'relative'} transition={'transform .3s ease-in-out'} _hover={{ transform: 'rotateY(180deg)' }} />
                    </Center>
                    <Text className="skills-card-name" color={'white'} fontWeight='bold' fontSize={'2xl'}>MongoDB</Text>
                </Box>
            </SimpleGrid>
            {/* Tools Section */}
            <Heading color={'text'} mb='30px'>And <strong style={{ color: '#4FC3F7' }}>Some </strong>Tools</Heading>
            <SimpleGrid gap={'30px'} columns={[1, 2, 3]} w={'80%'} m={'auto'} mb={'40px'} mt={'20px'}>
                {/* Github */}
                <Box className="skills-card" border={'1px solid white'} p={'5px'} borderRadius='15px' position={'relative'}>
                    <Center>
                        <Image className="skills-card-img" src={gitlogo} backgroundColor='white' borderRadius={'full'} w={'150px'} h={'150px'} position={'relative'} transition={'transform .3s ease-in-out'} _hover={{ transform: 'rotateY(180deg)' }} />
                    </Center>
                    <Text className="skills-card-name" color={'white'} fontWeight='bold' fontSize={'2xl'}>GitHub</Text>
                </Box>
                {/* Postman */}
                <Box className="skills-card" border={'1px solid white'} p={'5px'} borderRadius='15px' position={'relative'}>
                    <Center>
                        <Image className="skills-card-img" src={postman} w={'150px'} h={'150px'} position={'relative'} transition={'transform .3s ease-in-out'} _hover={{ transform: 'rotateY(180deg)' }} />
                    </Center>
                    <Text className="skills-card-name" color={'white'} fontWeight='bold' fontSize={'2xl'}>Postman</Text>
                </Box>
                {/* VS Code */}
                <Box className="skills-card" border={'1px solid white'} p={'5px'} borderRadius='15px' position={'relative'}>
                    <Center>
                        <Image className="skills-card-img" src={vscode} w={'150px'} h={'150px'} position={'relative'} transition={'transform .3s ease-in-out'} _hover={{ transform: 'rotateY(180deg)' }} />
                    </Center>
                    <Text className="skills-card-name" color={'white'} fontWeight='bold' fontSize={'2xl'}>VS Code</Text>
                </Box>
            </SimpleGrid>
        </div>
    )
};